import React from 'react';
import { connect } from 'react-redux';
import { MessageBox } from 'moovila-common';

import { clearMessageBox } from '../actions';

const GlobalMessageBox = ({messageBox, clearMessageBox}) => {
  if (!messageBox) {
    return null;
  }
  return (
    <MessageBox
      backTo={false}
      title={messageBox.title}
      callback={clearMessageBox}
    >
      { messageBox.message }
    </MessageBox>
  );
};

export default connect(s => s, {
  clearMessageBox,
})(GlobalMessageBox);



// WEBPACK FOOTER //
// ./src/components/GlobalMessageBox.js